// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".blog-page-info[data-v-21659d64]{margin:24px 0;text-align:center}.blog-page-info .tag[data-v-21659d64]{display:inline-block;font-size:14px;margin:0 12px}.blog-page-info .tag.linked[data-v-21659d64]{-webkit-text-decoration:underline;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
